import React from "react";

const Shareholders = () => {
  return <div></div>;
};

export default Shareholders;
